module.exports = __webpack_public_path__ + "static/media/logo-fresenius-txt.17cdea41.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-fresenius-txt.png
// module id = 570
// module chunks = 0